import { CSSObjectWithLabel, ControlProps, GroupBase } from "react-select";
import { OptionType } from "../../../../../app/utils/optionSelectType";
import { Button } from "../../../../components/ui/button";
import { BasicInput } from "../../../../components/BasicInput";
import { BasicSelect } from "../../../../components/BasicSelect";
import { useUserFormController } from "./useUserFormController";
import { states } from "../../../../../app/utils/states";
import { phoneMask } from "../../../../../app/utils/phoneFormater";
import { zipCodeMask } from "../../../../../app/utils/zipCodeFormater";
import { useAuth } from "@/app/hooks/useAuth";
import { accountType } from "@/app/utils/accountType";

const customStyles = {
  control: (
    base: CSSObjectWithLabel,
    props: ControlProps<OptionType, false, GroupBase<OptionType>>,
  ): CSSObjectWithLabel => ({
    ...base,
    borderRadius: "6px",
    border: props.isFocused ? "2px solid black" : "1px solid hsl(var(--input))",
    boxShadow: "black",
    "&:hover": {
      border: "1px solid hsl(var(--input))",
    },
    backgroundColor: "#fff",
  }),
  placeholder: (base: CSSObjectWithLabel) => ({
    ...base,
    color: "black",
  }),
};

export const UserForm = () => {
  const {
    methods,
    handleUserInfoSubmit,
    isPending,
    handleAccountNumberBlur,
    handleCepRequest,
    optionBanks,
  } = useUserFormController();

  const { isAdmin } = useAuth();

  return (
    <div className="w-full md:w-[380px] lg:w-[650px] xl:w-[850px] 2xl:w-[1150px]">
      <form onSubmit={methods.handleSubmit(handleUserInfoSubmit)}>
        <div className="rounded-lg border-[1px] border-[#E5E5E5] bg-white02 p-5">
          <h2 className="mb-5 font-semibold text-info">Informações pessoais</h2>
          <div className="flex flex-col gap-5 xl:flex-row xl:items-center">
            <BasicInput
              label="Nome"
              name="name"
              type="text"
              error={methods.formState.errors.name?.message}
            />
            <BasicInput
              label="Data de nascimento"
              name="birthDate"
              type="date"
              error={methods.formState.errors.birthDate?.message}
            />
          </div>
          <div className="mt-5 flex flex-col gap-5 xl:flex-row xl:items-center">
            <BasicInput
              label="Número de telefone"
              name="phone"
              type="text"
              onInput={phoneMask}
              error={methods.formState.errors.phone?.message}
            />
            <BasicInput
              label="Email"
              name="email"
              type="text"
              error={methods.formState.errors.email?.message}
            />
          </div>
        </div>

        <div className="my-5 rounded-lg border-[1px] border-[#E5E5E5] bg-white02 p-5">
          <h2 className="mb-5 font-semibold text-info">Endereço</h2>
          <div className="mb-5">
            <BasicInput
              label="CEP"
              name="address.zipCode"
              type="text"
              onInput={zipCodeMask}
              maxLength={9}
              onBlur={(e) => handleCepRequest(e.target.value)}
              error={methods.formState.errors.address?.zipCode?.message}
            />
          </div>
          <div className="flex flex-col gap-5 xl:flex-row xl:items-center">
            <BasicInput
              label="Rua"
              name="address.street"
              type="text"
              error={methods.formState.errors.address?.street?.message}
            />
            <BasicInput
              label="Número"
              name="address.number"
              type="text"
              error={methods.formState.errors.address?.number?.message}
            />
          </div>
          <div className="mt-5 flex flex-col gap-5 xl:flex-row xl:items-center">
            <BasicInput
              label="Bairro"
              name="address.neighborhood"
              type="text"
              error={methods.formState.errors.address?.neighborhood?.message}
            />
            <BasicInput
              label="Complemento"
              name="address.complement"
              type="text"
              error={methods.formState.errors.address?.complement?.message}
            />
          </div>
          <div className="mt-5 flex flex-col gap-5 xl:flex-row xl:items-center">
            <BasicInput
              label="Cidade"
              name="address.city"
              type="text"
              error={methods.formState.errors.address?.city?.message}
            />
            <BasicSelect
              label="UF"
              name="address.state"
              options={states}
              placeholder="Selecione o seu estado"
              styles={customStyles}
              error={methods.formState.errors.address?.state?.message}
            />
          </div>
        </div>

        {!isAdmin && (
          <div className="rounded-lg border-[1px] border-[#E5E5E5] bg-white02 p-5">
            <h2 className="mb-5 font-semibold text-info">
              Informações bancárias
            </h2>

            <div className="flex flex-col gap-5 xl:flex-row xl:items-center">
              <BasicSelect
                label="Banco"
                name="bankAccount.bank"
                options={optionBanks}
                placeholder="Selecione seu banco"
                styles={customStyles}
                error={methods.formState.errors.bankAccount?.bank?.message}
              />
            </div>
            <div className="mt-5 flex flex-col gap-5 xl:flex-row xl:items-center">
              <BasicSelect
                label="Tipo de conta"
                name="bankAccount.accountType"
                options={accountType}
                placeholder="Selecione seu tipo de conta"
                styles={customStyles}
                error={
                  methods.formState.errors.bankAccount?.accountType?.message
                }
              />
              <BasicInput
                label="Agência"
                name="bankAccount.agency"
                type="text"
                error={methods.formState.errors.bankAccount?.agency?.message}
              />
              <BasicInput
                label="Conta"
                name="bankAccount.account"
                type="text"
                onBlur={handleAccountNumberBlur}
                error={methods.formState.errors.bankAccount?.account?.message}
              />
            </div>
          </div>
        )}

        <div className="mt-8 flex items-center justify-end gap-2">
          <Button
            type="button"
            className="rounded-full bg-white02 text-xs font-bold text-primary"
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            disabled={isPending}
            className="rounded-full bg-primary text-xs font-bold text-white01"
          >
            Salvar
          </Button>
        </div>
      </form>
    </div>
  );
};
